<template>
  <div>
    <label class="d-flex flex-row align-center"> Status do cupom </label>

    <v-menu ref="menu" v-model="menu" transition="scale-transition" width="260" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field :value="getLabel" outlined hide-details readonly v-bind="attrs" v-on="on" @click="menu = true">
          <template #append>
            <mf-icon class="cursor-pointer" icon="keyboard_arrow_down" @click="menu = true" />
          </template>
        </v-text-field>
      </template>

      <v-card>
        <v-card-text>
          <div v-for="coupon in couponStatus" :key="coupon.value" cols="3" class="py-0">
            <v-checkbox
              v-model="selectedOptions"
              :label="coupon.label"
              :value="coupon.value"
              multiple
              class="my-0 py-0"
              :disabled="isTheLastActiveCoupon(coupon.value)"
              @change="$emit('change', $event)"
            ></v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'SelectCouponStatus',
  props: {
    selected: {
      type: Array,
      required: false,
      default: () => ['RECOVERED', 'NOT_RECOVERED', 'NOT_PROCESSED'],
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    getLabel() {
      if (this.selectedOptions.length === 3) return 'Todos'
      if (this.selectedOptions.length === 2) return '2 selecionados'
      const selectedIndex = this.couponStatus.findIndex((item) => item.value === this.selectedOptions[0])
      return `${this.couponStatus[selectedIndex].label}`
    },
    selectedOptions: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
    couponStatus() {
      return [
        { label: 'Recuperado', value: 'RECOVERED' },
        { label: 'Não recuperado', value: 'NOT_RECOVERED' },
        { label: 'Ainda não gerado', value: 'NOT_PROCESSED' },
      ]
    },
  },
  methods: {
    isTheLastActiveCoupon(currentCoupon) {
      if (!this.selectedOptions) return false
      return this.selectedOptions.includes(currentCoupon) && this.selectedOptions.length === 1
    },
  },
}
</script>

<style lang="scss" scoped></style>
